import { AdminLayout } from "@/views/layouts/AppLayout";
import { IndexResearchPage } from "@/views/pages/indexResearch/IndexResearchPage";
import { IndexVersionInfoPage } from "@/views/pages/indexResearch/IndexVersionInfoPage";
import type { AdminRouteObject } from "../index";

/** 指数管理路由，沿用 Vue 指数查看、处理和管理权限。 */
export const indexResearchRoutes: AdminRouteObject = {
    path: "/indexResearch",
    element: <AdminLayout />,
    handle: { title: "指数管理" },
    children: [
        {
            index: true,
            element: <IndexResearchPage />,
            handle: {
                title: "指数管理",
                permissions: ["ROLE_CATEGORY_INDEX_R", "ROLE_CATEGORY_INDEX_DEAL", "ROLE_CATEGORY_INDEX_MANAGE"]
            }
        },
        {
            path: "versionInfo/:id",
            element: <IndexVersionInfoPage />,
            handle: {
                title: "版本详情",
                permissions: ["ROLE_CATEGORY_INDEX_R", "ROLE_CATEGORY_INDEX_DEAL", "ROLE_CATEGORY_INDEX_MANAGE"]
            }
        }
    ]
};

export default indexResearchRoutes;
